import React from 'react';
import PartnerSectionHeader from '../common/PartnerSectionHeader';
import {TaxProfileSection} from 'src/constants/constants';
import ActionRequired from 'src/CpaCenterV2/common/ActionRequired/ActionRequired';
import {CreateQueryDrawerTab} from 'src/store/app/app.reducer';
import BusinessDeductions from './components/BusinessDeductions';

const PartnerDeductions = () => {
  return (
    <div style={{display: 'flex', flex: 1, overflow: 'hidden'}}>
      <div
        style={{
          display: 'flex',
          flex: 0.75,
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
        <PartnerSectionHeader
          sectionName="Deductions"
          section={TaxProfileSection.Deductions}
        />
        <div style={{overflowY: 'auto'}}>
          <BusinessDeductions />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flex: 0.25,
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
        <ActionRequired
          title="Comments"
          dontAllowAdd
          types={[CreateQueryDrawerTab.TAX_PROFILE]}
          taxProfileSection={TaxProfileSection.Deductions}
        />
      </div>
    </div>
  );
};

export default PartnerDeductions;
